__turbopack_context__.v({
  "content": "RetailersMap-module__zbFSKq__content",
  "map": "RetailersMap-module__zbFSKq__map",
  "marker": "RetailersMap-module__zbFSKq__marker",
  "retailers": "RetailersMap-module__zbFSKq__retailers",
  "search": "RetailersMap-module__zbFSKq__search",
  "searchButton": "RetailersMap-module__zbFSKq__searchButton",
  "searchInput": "RetailersMap-module__zbFSKq__searchInput",
  "text": "RetailersMap-module__zbFSKq__text",
});
